import { useCookies, Cookies } from "react-cookie"
import { Navigate, Outlet, useNavigate } from "react-router-dom"
import * as Yup from "yup"
import { useSelector } from "react-redux"

export const ProtectedRoutes = () => {
  const [cookies] = useCookies(["authToken"])
  const token = cookies.authToken ? true : false

  return token ? <Outlet /> : <Navigate to="/login" />
}

export const UnProtectedRoutes = () => {
  const [cookies] = useCookies(["authToken"])
  const token = cookies.authToken ? true : false

  return token ? <Navigate to="/dashboard" /> : <Outlet />
}

export const SlashRouteHandler = () => {
  const [cookies] = useCookies(["authToken"])
  const token = cookies.authToken ? true : false

  return token ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
}

export const GetUserToken = () => {
  const cookies = new Cookies()
  const token = cookies.get("authToken")

  return token
}

export const handleOnchange = (e, revegexValidation, formik) => {
  const inputValue = e?.target?.value
  if (revegexValidation) {
    const isValid = revegexValidation
      ? revegexValidation.test(inputValue)
      : false
    const fieldName = e?.target?.name
    if (isValid) {
      formik.setFieldValue([fieldName], inputValue)
    }
  } else {
    formik.setFieldValue(e?.target?.name, inputValue)
  }
}

export const handleOnBlur = (e, formik, trimDots) => {
  let fieldName = e?.target?.name
  let value = formik.values[fieldName]?.trim()

  if (trimDots) {
    value = value.replace(/^\.+|\.+$/g, "")
  }

  formik.setFieldValue(fieldName, value)
}

export const generateRandomPassword = (length) => {
  let result = ""
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456769!/[*/-+$#&^@!~()]/"
  const charactersLength = characters.length
  let counter = 0

  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
    counter += 1
  }

  if (/[*/\-+$#&^@!~()]/.test(result)) {
    return result
  }

  return generateRandomPassword(10)
}

export const validateImage = (includePDF) => {
  const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "image/jpg"]
  if (includePDF) {
    SUPPORTED_FORMATS.push("application/pdf")
  }
  return Yup.object().shape({
    filename: Yup.mixed()
      .test(
        "fileFormat",
        `File format is not supported, Please use .jpg/.png/.jpeg${
          includePDF ? "./pdf" : ""
        } format support`,
        (value) => value && SUPPORTED_FORMATS.includes(value.type)
      )
      .test(
        "fileSize",
        "File must be less than 500KB",
        (value) => value && value.size <= 512000
      ),
  })
}

export const transformData = (data) => {
  const keys = Object.keys(data)

  let transformedData = []

  for (const key of keys) {
    transformedData = [
      ...transformedData,
      {
        [key]: data[key],
      },
    ]
  }

  return transformedData
}

export const useHandleUnauthorizedAccess = () => {
  const [, , removeCookie] = useCookies(["authToken"])
  const navigate = useNavigate()

  const handleAccess = ({ code }) => {
    if (code === 401 || code === 403) {
      removeCookie("authToken")
      navigate("/login")
    }
  }

  return { handleAccess }
}

export const HasModulePermission = (moduleName, permissionName) => {
  const modulePermissions = useSelector(
    (state) => state.modulePermissions.modulePermissionList
  )

  if (!modulePermissions || !modulePermissions[moduleName]) {
    return false
  }

  const permissionsList = modulePermissions[moduleName]

  return permissionsList.some(
    (permission) => permission.permission === permissionName
  )
}

export const getStatusClassName = (status) => {
  switch (status) {
    case "Pending":
    case "Preparing":
      return "badges_warning"
    case "Confirmed":
    case "Unavailable":
      return "badges_info"
    case "Completed":
    case "Available":
    case "Approved":
      return "badges_success"
    case "Cancelled":
    case "Rejected":
    case "Faulted":
      return "badges_danger"
    default:
      return ""
  }
}
